import React from 'react'

interface InPersonIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const InPersonIcon: React.FC<InPersonIconProps> = ({
  color = '#000000',
  gradient,
  width = 9,
  height = 11,
  alt = 'In-person icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 8.74 10.48'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M4.31,5.05C5,5.05,5.6,4.8,6.09,4.31c0.49-0.49,0.74-1.09,0.74-1.78c0-0.69-0.25-1.29-0.74-1.78C5.6,0.25,5,0,4.31,0C3.61,0,3.01,0.25,2.52,0.74S1.78,1.83,1.78,2.52c0,0.69,0.25,1.29,0.74,1.78C3.01,4.8,3.61,5.05,4.31,5.05z M2.96,1.17C3.33,0.8,3.77,0.61,4.31,0.61c0.53,0,0.97,0.18,1.35,0.56c0.38,0.38,0.56,0.82,0.56,1.35c0,0.53-0.18,0.97-0.56,1.35C5.28,4.25,4.84,4.43,4.31,4.43c-0.53,0-0.97-0.18-1.35-0.56C2.58,3.5,2.4,3.06,2.4,2.52C2.4,1.99,2.58,1.55,2.96,1.17z'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M8.72,8.06C8.71,7.85,8.68,7.63,8.64,7.4C8.6,7.16,8.54,6.94,8.47,6.73C8.41,6.52,8.32,6.31,8.2,6.11C8.08,5.9,7.94,5.72,7.79,5.57C7.63,5.42,7.43,5.29,7.2,5.2C6.97,5.11,6.71,5.06,6.44,5.06c-0.11,0-0.21,0.04-0.41,0.17C5.91,5.32,5.76,5.41,5.6,5.51C5.46,5.6,5.28,5.68,5.05,5.76C4.82,5.83,4.6,5.87,4.37,5.87c-0.22,0-0.45-0.04-0.68-0.11C3.47,5.68,3.28,5.6,3.14,5.51c-0.16-0.1-0.3-0.19-0.43-0.28c-0.2-0.13-0.3-0.17-0.41-0.17c-0.27,0-0.53,0.05-0.76,0.14C1.32,5.29,1.12,5.42,0.95,5.57C0.8,5.72,0.66,5.9,0.54,6.11c-0.11,0.2-0.21,0.41-0.27,0.62C0.2,6.94,0.15,7.16,0.11,7.4C0.06,7.63,0.04,7.85,0.02,8.06C0.01,8.26,0,8.47,0,8.68c0,0.55,0.17,0.99,0.52,1.32c0.34,0.32,0.79,0.49,1.33,0.49H6.9c0.54,0,0.99-0.16,1.33-0.49c0.34-0.33,0.52-0.77,0.52-1.32C8.74,8.47,8.74,8.26,8.72,8.06z M7.8,9.55C7.58,9.76,7.28,9.87,6.9,9.87H1.85c-0.39,0-0.68-0.1-0.91-0.32C0.72,9.34,0.61,9.06,0.61,8.68c0-0.2,0.01-0.39,0.02-0.58c0.01-0.18,0.04-0.38,0.08-0.6C0.75,7.29,0.8,7.1,0.85,6.92c0.05-0.17,0.13-0.34,0.22-0.5c0.09-0.16,0.19-0.29,0.3-0.4c0.11-0.1,0.24-0.18,0.39-0.25c0.14-0.06,0.31-0.09,0.48-0.09c0.02,0.01,0.06,0.03,0.12,0.07c0.13,0.08,0.27,0.18,0.43,0.28c0.18,0.12,0.41,0.22,0.69,0.31c0.29,0.09,0.58,0.14,0.87,0.14s0.58-0.05,0.87-0.14c0.28-0.09,0.51-0.19,0.69-0.31c0.16-0.11,0.31-0.2,0.43-0.28c0.06-0.04,0.1-0.06,0.12-0.07c0.18,0,0.34,0.04,0.48,0.09c0.16,0.06,0.29,0.14,0.39,0.25c0.11,0.11,0.21,0.24,0.3,0.4c0.09,0.16,0.17,0.33,0.22,0.5C7.95,7.1,8,7.29,8.03,7.51C8.07,7.72,8.1,7.92,8.11,8.1v0c0.01,0.19,0.02,0.38,0.02,0.58C8.13,9.06,8.02,9.34,7.8,9.55z'
      />
    </svg>
  )
}

export default InPersonIcon
